<!-- Copyright 2023 Midas Healthcare Solutions - All Rights Reserved -->
<mat-form-field class="example-chip-list" appearance="fill" *transloco="let t">
  <mat-label>{{ t('Filter by Formulary') }}</mat-label>
  <mat-chip-grid #chipGrid>
    <mat-chip-row *ngFor="let nm of items" (removed)="remove(nm)">
      {{ nm.medicationGroupDescription }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  </mat-chip-grid>
  <input
    #searchInput
    [formControl]="searchCtrl"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let nm of filteredItems | async" [value]="nm">
      {{ nm.medicationGroupDescription }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
